

const WhatsappFooter = () => {

  return (
    <div>
      <footer style={{
        border: '1px solid red',
        padding: '10px',
        borderRadius: '10px',
        margin: '10px',
      }} >
        write a message...
        <div contentEditable={true} suppressContentEditableWarning={true} style={{ border: "1px solid gray" }} >
          <p style={{
            padding: 0,
            margin: 0,
            height: "20px",
          }}>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default WhatsappFooter;
